import { render, staticRenderFns } from "./FormBooleanInput.vue?vue&type=template&id=fdd206be&"
import script from "./FormBooleanInput.vue?vue&type=script&lang=js&"
export * from "./FormBooleanInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports